import { IMediaObject } from "@models/entity-models";

export interface IAlert {
    id?: string;
    type?: string;
    msg?: any;
    persist?: boolean;
    timeShown?: number;
    /**
     * will show progress animations while the promise is active if provided
     */
    promise?: ng.IPromise<any>;

    /**
     * will show progress animations while the promise is active if provided
     */
    promiseVue?: Promise<any>;

    /**
     * the message to show if the promise is a success.  If left null, alert will continue to show the original msg.  if it fails, the promise reason will become the msg
     */
    successMsg?: string;
    /**
     * on promise failure, controls whether the failure reason of the promise will be shown as the msg.  Defaults to true.
     */
    showPromiseReasonOnFail?: boolean;
    /**
     * a url to an angular template that will be used to fill the content instead of the msg
     */
    templateUrl?: string;
    /**
     * HTML string that will be used to fill the content instead of the msg
     */
    template?: string;
    /**
     * a scope to go along with the templateUrl
     */
    scope?: ng.IScope;
}

export interface IDialog {
    content: JQuery;
    buttons: IDialogButton[];
    type: string;
    visible: boolean;
    keypress: (e: JQueryEventObject) => void;
    tracker: ng.IPromiseTracker; // shows a progress bar at the top
    fullHeight: boolean;
    remValues?: string[];
    dialogProps?: IDialogProp;
    dialogType?: IDialogType;
}
//TODO:Dialog properties need to be fill remaining properties from all type dialogs
//else need to remove this
export interface IDialogProp {
    msg: string,
    modelValue?: any,
    source?: any,
    labelField?: string,
    valueField?: any,
}

export interface IDialogType {
    media: boolean,
    input: boolean,
    confirm: boolean
}

export interface IDialogButton<TArgs = DialogButtonArgs> {
    title: string;
    icon: string;
    callback: (args: TArgs) => void;
    visible: boolean;
}

export interface IDialogOptions {
    type?: string;
    content?: any;
    templateUrl?: string;
    template?: string;
    buttons?: IDialogButton[];
    buttonArgs?: () => DialogButtonArgs; // a function that returns the args
    scope?: ng.IScope;
    tracker?: ng.IPromiseTracker;
    fullHeight?: boolean; // instead of an auto height dialog, make it take up the whole screen
    //added for dynamic input dialog 
    remValues?: string[];
    dialogProps?: IDialogProp;
    //dialogType?: IDialogType;
}

export enum eInputDialogType {
    text = "text",
    html = "html",
    textArea = "textArea",
    select = "select",
    snap = "snap",
}

export interface IInputOptions {
    msg?: string;
    value?: any;
    inputType?: string;
    source?: any;
    valueField?: string;
    labelField?: string;
    buttons?: IDialogButton[];
}

export enum eMediaFilter {
    all,
    images,
    videos,
    imagesAndVideos,
    environments
}

export interface IMediaDialogOptions {
    startPath?: string;
    buttons?: MediaDialogButton[];
    filter?: eMediaFilter;
    apiPath?: string;
    rootDir?: string;
    open?: (file: IMediaObject) => void;
}

export interface IDialogService {
    alerts: IAlert[];
    dialogs: IDialog[];
    progress(options: IAlert);
    confirm(confirmMessage: string, yesCallback: () => void, noCallback?: () => void);
    alert(alert: IAlert);
    closeAlert(index);
    dialog(options: IDialogOptions): IDialog;
    input(options);
    mediaSelect(options);
}

export class DialogButtonArgs {
    constructor() {
        this.close = true;
    }
    public close: boolean;
}

export class InputDialogButtonArgs extends DialogButtonArgs {
    constructor() {
        super();
    }
    public value: any;
}

export class MediaDialogButtonArgs extends DialogButtonArgs {
    constructor() {
        super();
    }
    public selectedItem: IMediaObject;
}

export class DialogButton<TArgs = DialogButtonArgs> implements IDialogButton<TArgs> {
    constructor(
        public title: string,
        public icon: string,
        public callback: (args: TArgs) => void = null,
        public visible = true
    ) { }
}

export class InputDialogButton extends DialogButton<InputDialogButtonArgs> { }
export class MediaDialogButton extends DialogButton<MediaDialogButtonArgs> { }